import api, { PostContractRequest } from "./api";
import { ActionContext } from "vuex";
import log from "loglevel";

interface State {}

type MyActionContext = ActionContext<State, State>;

export default {
  namespaced: true,
  state: {} as State,
  getters: {},
  actions: {
    // 通常の契約
    async postContractDefault(
      context: MyActionContext,
      params: PostContractRequest
    ) {
      try {
        const res = await api.postContractDefault(params);
        return res.data;
      } catch (error) {
        log.error("postContractDefault error:", error);
        throw error;
      }
    },
    // Wacom 優待フロー
    async postContractWacom(
      context: MyActionContext,
      params: PostContractRequest
    ) {
      try {
        const res = await api.postContractWacom(params);
        return res.data;
      } catch (error) {
        log.error("postContractWacom error:", error);
        throw error;
      }
    },
    // 既存 優待フロー
    async postContractContinued(
      context: MyActionContext,
      params: PostContractRequest
    ) {
      try {
        const res = await api.postContractContinued(params);
        return res.data;
      } catch (error) {
        log.error("postContractContinued error:", error);
        throw error;
      }
    },
    // アクティベーションコードのWacom優待
    async postContractActivationCodeWacomOffer(
      context: MyActionContext,
      params: PostContractRequest
    ) {
      try {
        const res = await api.postContractActivationCodeWacomOffer(params);
        return res.data;
      } catch (error) {
        log.error("postContractActivationCodeWacomOffer error:", error);
        throw error;
      }
    },
    // /ice/application-pay経由の申し込みフロー
    async postContractPay(
      context: MyActionContext,
      params: PostContractRequest
    ) {
      try {
        const res = await api.postContractPay(params);
        return res.data;
      } catch (error) {
        log.error("postContractPay error:", error);
        throw error;
      }
    },
    // DEBUT優待
    async postContractDebutOffer(
      context: MyActionContext,
      params: PostContractRequest
    ) {
      try {
        const res = await api.postContractDebutOffer(params);
        return res.data;
      } catch (error) {
        log.error("postContractDebutOffer error:", error);
        throw error;
      }
    }
  },
  mutations: {}
};
